import {element_exists} from "../../functions";

export var fnDashGlobalSearch = function () {

    if (!element_exists('.employee.dashboard')) return false;

    $('input[name="global_search"]').on('input', function (e) {

        var value = $(this).val();

        $('.table-responsive thead tr.filters th:first-child input').each(function () {

            $(this).val(value);
            $(this).trigger('change');
        });
    });

}